import { render, staticRenderFns } from "./DefaultHistory.vue?vue&type=template&id=8b07f1c2&"
import script from "./DefaultHistory.vue?vue&type=script&lang=js&"
export * from "./DefaultHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports